import { gql } from '@apollo/client';

const AZSAPP_CLASSROOM_SETTINGS_FRAGMENT = gql`
  fragment BaseAzsappClassroomSettings on AzsappClassroomSettings {
    accessBookAfterAssignment {
      enabled
    }
  }
`;

export default AZSAPP_CLASSROOM_SETTINGS_FRAGMENT;
